export default {
    '个人中心':'个人中心',
    '编辑个人资料':'编辑个人资料',
    '编辑个人领域信息':'编辑个人领域信息',
    '本机构信息':'本机构信息',
    '编辑机构信息':'编辑机构信息',
    '设备管理':'设备管理',
    '场所管理':'场所管理',
    '关联设备':'关联设备',
    '学年学期':'学年学期',
    '新增学年':'新增学年',
    '编辑学年':'编辑学年',
    '入学年份':'入学年份',
    '班级管理':'班级管理',
    '教职工':'教职工',
    '新增教职工':'新增教职工',
    '编辑教职工':'编辑教职工',
    '市民':'市民',
    '新增市民':'新增市民',
    '编辑市民':'编辑市民',
    '学生':'学生',
    '新增学生':'新增学生',
    '编辑学生':'编辑学生',
    '家长':'家长',
    '编辑家长':'编辑家长',
    '角色管理':'角色管理',
    '新增角色':'新增角色',
    '编辑角色':'编辑角色',
    '管理成员':'管理成员',
    '测试管理':'测试管理',
    '新增计划':'新增计划',
    '查看计划':'查看计划',
    '成绩查询':'成绩查询',
    '测试记录':'测试记录',
    '锻炼记录':'锻炼记录',
    '竞技排名赛':'竞技排名赛',
    '新增竞技排名赛':'新增竞技排名赛',
    '编辑竞技排名赛':'编辑竞技排名赛',
    '竞技排名赛详情':'竞技排名赛详情',
    '竞技排名赛数据':'竞技排名赛数据',
    '作业管理':'作业管理',
    '发布作业':'发布作业',
    '作业详情':'作业详情',
    '编辑作业':'编辑作业',
    '测试结果':'测试结果',
    '详情':'详情',
    '随堂练':'随堂练',
    '随堂测':'随堂测',
    '随堂赛':'随堂赛',
    '个性化训练列表':'个性化训练列表',
    '新增个性化训练':'新增个性化训练',
    '查看个性化训练':'查看个性化训练',
    '数据列表':'数据列表',
    '运动会管理':'运动会管理',
    '新增运动会':'新增运动会',
    '管理运动会':'管理运动会',
    '编排':'编排',
    '日程表':'日程表',
    '运动风采':'运动风采',
    '学校画像':'学校画像',
    '年级画像':'年级画像',
    '班级画像':'班级画像',
    '班级详情':'班级详情',
    '学生画像':'学生画像',
    '院系管理':'院系管理',
    '专业管理':'专业管理',
    '赛事列表':'赛事列表',
    '新增闯关挑战赛':'新增闯关挑战赛',
    '编辑闯关挑战赛':'编辑闯关挑战赛',
    '闯关挑战赛详情':'闯关挑战赛详情',
    '新增机构':'新增机构',
    '编辑机构':'编辑机构',
    '查看机构':'查看机构',
    '组织结构管理':'组织结构管理',
    '用户管理':'用户管理',
    '新增用户':'新增用户',
    '编辑用户':'编辑用户',
    '机构信息管理':'机构信息管理',
    '资源列表':'资源列表',
    '新增资源':'新增资源',
    '编辑资源':'编辑资源',
    '校本资源':'校本资源',
    '新增校本资源':'新增校本资源',
    '编辑校本资源':'编辑校本资源',
    // 2025.3.19

    // 2025.5.21
    'Banner配置':'Banner配置',
    '编辑Banner配置':'编辑Banner配置',
    '查看Banner配置':'查看Banner配置',
    '资源分类':'资源分类', 

    // 2026.1.4
    '自由锻炼':'自由锻炼',
    '趣味锻炼':'趣味锻炼',
    '竞技场':'竞技场',
    '机构主页管理':'机构主页管理',
    '主页发布管理':'主页发布管理',
    '分类管理':'分类管理',
    '新增主页':'新增主页',
    '编辑主页':'编辑主页',

    // 2026.6.25
    '宣传页管理':'宣传页管理',
    '宣传页配置':'宣传页配置',
    '新增宣传页':'新增宣传页',
    '编辑宣传页':'编辑宣传页',
}